import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

//STYLES
import * as YourBookingsStyles from "../styles/yourBookings";

function ApproveBookingItem(props) {
    const [open, setOpen] = useState(false);
    const [showQuestions, setShowQuestions] = useState(false);

    useEffect(() => {
        let showQuestions = false;
        for (const question of props.questions) {
            const answer = props.booking.answers.find((ans) => ans.questionUUID == question.uuid);
            if (answer != null) {
                question.answer = answer.answer;
                showQuestions = true;
            }
        }
        setShowQuestions(showQuestions);
    }, []);

    function handleBookingClicked() {
        setOpen(!open);
    }

    function CapsFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <div>
            <Card style={YourBookingsStyles.card}>
                <Card.Body>
                    <Row>
                        <Col>{props.booking.userName}</Col>
                        <Col>{props.booking.departmentName}</Col>
                        <Col>{props.booking.roomName}</Col>
                        <Col>{props.booking.startDate}</Col>
                        <Col>{props.booking.session}</Col>
                        <Col>{props.booking.sessionDes}</Col>
                        <Col style={YourBookingsStyles.buttonsContainer}>
                            <OverlayTrigger placement="top" overlay={<Tooltip>Approve</Tooltip>}>
                                <Button onClick={props.editApprovalStatus.bind(this, props.booking.uuid, props.bookingLinks, "approved")}>
                                    <i className="fa-solid fa-check"></i>
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip>Deny</Tooltip>}>
                                <Button onClick={props.editApprovalStatus.bind(this, props.booking.uuid, props.bookingLinks, "denied")}>
                                    <i className="fa-solid fa-xmark"></i>
                                </Button>
                            </OverlayTrigger>
                            {showQuestions && (
                                <OverlayTrigger placement="top" overlay={<Tooltip>{open ? "Hide Questions" : "Show Questions"}</Tooltip>}>
                                    <Button onClick={handleBookingClicked}>
                                        <i className="fa-solid fa-circle-question"></i>
                                    </Button>
                                </OverlayTrigger>
                            )}
                        </Col>
                    </Row>
                    {showQuestions && (
                        <Row style={open ? YourBookingsStyles.contentShow : YourBookingsStyles.content}>
                            <Col>
                                <strong>Questions</strong> <br /> <br />
                                {props.questions.map((question, index) => {
                                    return (
                                        <div key={index}>
                                            {question.question} <br />
                                            {props.booking.answers.find((answer) => answer.questionUUID == question.uuid).answer}
                                            <br /> <br />
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}

export default ApproveBookingItem;
